import PouchDB from 'pouchdb';
import PouchDBFind from 'pouchdb-find';
import { COUCHDB_CONFIG } from './secrets';
import authService from '../services/auth-service';

// Add the find plugin
PouchDB.plugin(PouchDBFind);

// Custom fetch wrapper that adds auth headers to every request
const authenticatedFetch = (url, opts = {}) => {
  const token = authService.getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(opts.headers || {}),
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
  
  return fetch(url, {
    ...opts,
    headers
  });
};

// Internal PouchDB instance - keep it persistent
let dbInstance = null;

// Getter function - always returns current authenticated instance
export const getDB = () => {
  if (!dbInstance) {
    dbInstance = new PouchDB(COUCHDB_CONFIG.url, {
      skip_setup: true,
      fetch: authenticatedFetch,
      adapter: 'http',
      auto_compaction: false
    });
  }
  return dbInstance;
};

// Update headers when token changes - don't close, just update fetch
export const updateDBHeaders = () => {
  // Keep the instance alive, just update the fetch headers
  // The authenticatedFetch will use the new token on next request
};

// Test connection
const testDirectConnection = async () => {
  try {
    const info = await getDB().info();
    return { success: true, info };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Direct fetch method as backup (matches your server CORS setup)
const fetchAllDocs = async () => {
  try {
    const token = authService.getToken();
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
    
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000); // 15 second timeout
    
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    const response = await fetch(`${apiUrl}/api/_all_docs?include_docs=true`, {
      method: 'GET',
      credentials: 'include',
      headers,
      signal: controller.signal
    });
    
    clearTimeout(timeoutId);
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error('Request timeout. Please check your internet connection.');
    }
    throw error;
  }
};

// Backward compatibility - deprecated, use getDB() instead
let directDBInstance = null;
export const directDB = new Proxy({}, {
  get(target, prop) {
    if (!directDBInstance) directDBInstance = getDB();
    return directDBInstance[prop];
  }
});

export { testDirectConnection, fetchAllDocs };